import React from "react";
import { createDrawerNavigator, DrawerItem } from "@react-navigation/drawer";
import { KeyExchangeTabs } from "./tabs/KeyExchangeTabs";
import { HeaderBar } from "./Header";
import { PwCrackingScreen1, PwCrackingScreen2, StrengthScreen } from "../features/cracking";
import { AboutScreen } from "../screens/AboutScreen";
import { Outlines, Sizing, useTheme } from "../theme";
import { Image, ScrollView, View } from "react-native";
import { Spacer, Highlight } from "../components";
import { SideMenuParamList } from "./types";
import { CryptoTabs } from "./tabs/CryptoTabs";

export const Drawer = createDrawerNavigator<SideMenuParamList>();

export const SideMenu = () => {
  const { colors } = useTheme();

  return (
    <Drawer.Navigator
      initialRouteName="About"
      screenOptions={{
        header: ({ navigation, route, options }) => (
          <HeaderBar title={options.drawerLabel as string} />
        ),
        drawerStyle: { width: Sizing.cs(460) },
      }}
      drawerContent={(props) => {
        // Super hacky workaround because React Naviagtion Drawer don't allow
        // Sections or anything like that.
        // This is awful, but it works.
        const { state, descriptors, navigation } = props;
        const Item = (props: { route: any }) => {
          const { drawerLabel, drawerActiveTintColor } =
            descriptors[props.route.key].options;
          return (
            <DrawerItem
              key={props.route.key}
              label={({ color }) => (
                <Highlight color={color}>{drawerLabel}</Highlight>
              )}
              focused={
                state.routes.findIndex((e) => e.name === props.route.name) ===
                state.index
              }
              activeTintColor={drawerActiveTintColor}
              onPress={() => navigation.navigate(props.route.name)}
            />
          );
        };

        const Section = (props: { text: string }) => (
          <View
            style={{
              borderBottomColor: colors.foreground.s200,
              borderBottomWidth: Outlines.borderWidth.hairline,
            }}
          >
            <Highlight text={props.text} />
          </View>
        );

        return (
          <View style={{ flex: 1 }}>
            <Image
              style={{ width: "100%", height: Sizing.cs(200) }}
              resizeMode="cover"
              source={require("../../assets/locks.jpg")}
            />
            <Spacer size="medium" />
            <ScrollView
              contentContainerStyle={{ paddingHorizontal: Sizing.layout.x30 }}
            >
              <Section text="Diffie-Hellman Workshop" />
              <Item route={state.routes[0]} />
              <Item route={state.routes[1]} />
              <Section text="MINT-Ferienprogramm" />
              <Item route={state.routes[2]} />
              <Item route={state.routes[3]} />
              <Item route={state.routes[4]} />
              <Section text="Allgemein" />
              <Item route={state.routes[5]} />
            </ScrollView>
          </View>
        );
      }}
    >
      <Drawer.Screen
        name="KeyExchange"
        component={KeyExchangeTabs}
        options={{ drawerLabel: "Schlüsseltausch" }}
      />
      <Drawer.Screen
        name="Crypto"
        component={CryptoTabs} // TODO tabs
        options={{ drawerLabel: "Crypto" }}
      />
      <Drawer.Screen
        name="PwCracking1"
        component={PwCrackingScreen1}
        options={{ drawerLabel: "Passwort-Cracking 1" }}
      />
      <Drawer.Screen
        name="StrengthEvaluator"
        component={StrengthScreen}
        options={{ drawerLabel: "Passwortstärke" }}
      />
      <Drawer.Screen
        name="PwCracking2"
        component={PwCrackingScreen2}
        options={{ drawerLabel: "Passwort-Cracking 2" }}
      />
      <Drawer.Screen
        name="About"
        component={AboutScreen}
        options={{ drawerLabel: "Impressum" }}
      />
    </Drawer.Navigator>
  );
};
